import { readStorage } from './storage'

// Client-side JWT utilities for session validation.
// No signature verification — that is the backend's job.
// These helpers only decode the payload to read the exp claim.

const decodeJwt = (token) => {
  try {
    if (!token || typeof token !== 'string') return null
    const parts = token.split('.')
    if (parts.length !== 3) return null
    return JSON.parse(atob(parts[1]))
  } catch (_) {
    return null
  }
}

// Returns the Date when the token expires, or null when the token is
// missing, malformed, or carries no exp claim.
export const getTokenExpiration = (token) => {
  const payload = decodeJwt(token)
  if (!payload || !payload.exp) return null
  return new Date(payload.exp * 1000)
}

// Returns true when:
//   • token is absent or not a string
//   • token is not a valid 3-part JWT
//   • token carries an exp claim that is in the past
//
// Returns false for a well-formed JWT with no exp claim
// (treat as "let the backend decide").
export const isTokenExpired = (token) => {
  if (!token) return true
  if (typeof token !== 'string' || token.split('.').length !== 3) return true
  const exp = getTokenExpiration(token)
  if (!exp) return false
  return exp <= new Date()
}

// Returns milliseconds until the token expires.
// Returns -1 when the expiry cannot be determined (no exp claim).
export const msUntilExpiry = (token) => {
  const exp = getTokenExpiration(token)
  if (!exp) return -1
  return exp.getTime() - Date.now()
}

// Read the current bearer token from localStorage.
// Handles both JSON-stringified and plain-string storage.
export const getStoredToken = () => {
  return readStorage('accessToken')
}
